import { render } from "./Resource.vue?vue&type=template&id=00954a95"
const script = {}

import exportComponent from "/Users/chad/work/cocos_cc/vue_cc_launch/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__